var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCardCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.895 16c-.99 0-1.454-.67-3.439-2.574l-4.203-4.16c-.764-.756-.764-1.89 0-2.647.764-.757 1.91-.757 2.675 0l4.203 4.16c.382.378.764.378.764.378.382 0 .764-.378.764-.378L19.977.567c.764-.756 1.91-.756 2.674 0 .765.757.765 1.891 0 2.648L12.334 13.426C10.307 15.646 9.886 16 8.895 16z",
    fill: "#49BC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCardCheckMark);
export default __webpack_public_path__ + "static/media/green-card-check-mark.b1754c599536caa72f5f27939ea7b951.svg";
export { ForwardRef as ReactComponent };